import { Stack, StackProps } from '@mui/material'
import { FC } from 'react'
import { MenuItemCard } from 'components/ordering/MenuItemCard'
import { MenuItem } from 'models'
import { calculateUnavailableMessageInMenu } from 'services'

interface MenuItemsListProps extends StackProps {
  items: MenuItem[]
  onItemClick: (item: MenuItem) => void
  unavailableMessage?: string
  calculateUnavailableMessageWhenSearching?: (item: MenuItem) => any
}

export const MenuItemsList: FC<MenuItemsListProps> = ({
  items,
  onItemClick,
  unavailableMessage,
  calculateUnavailableMessageWhenSearching,
  ...restProps
}) => {
  return (
    <Stack {...restProps} spacing={2}>
      {items?.map((item) => {
        const itemUnavailableMessage = calculateUnavailableMessageInMenu(
          item,
          unavailableMessage,
          calculateUnavailableMessageWhenSearching,
        )
        return (
          <MenuItemCard
            key={item.id}
            item={item}
            onClick={() => onItemClick(item)}
            unavailableMessage={itemUnavailableMessage}
            viewType="list"
          />
        )
      })}
    </Stack>
  )
}
